export const IMAGE_SVG_ICONS_TYPE = {
  ACCESS_FROM_ICON_LIB: 'access_from_icon_library',
};
